import React from 'react';

import { User } from '@front/common/src/types/commons';
import { BasketState } from '@front/common/src/ducks/common/basket';

import {
  getMembershipPaywallCTAText,
  getMembershipQuestions,
  MembershipOptIn,
} from '@front/customer/src/modals/membership-paywall/utils';
import useGetPrices from '@front/customer/src/hooks/use-get-prices';

import { translate } from '@front/i18n';

import Button from '@front/web-ui/src/components/button/button';

import {
  Content,
  MembershipFaq,
  PriceCardsContainer,
  StickyContainer,
  StyledStickyBottomWrapper,
  StyledWhiteSpacerRoundedBorders,
} from '../common';
import WellnessCleaningSpotHeader from '../wellness-cleaning-spot-header';

import SelectableCleaningMemberPriceCard from './selectable-cleaning-member-price-card';
import SelectableCleaningStandardPriceCard from './selectable-cleaning-standard-price-card';

export const MEMBERSHIP_PAYWALL_CLEANING_PRICES_LOADED_TEST_ID = 'membership-paywall-cleaning-prices-loaded-test-id';

const t = translate('modals.membership_paywall');

type SpotContentProps = {
  duration: BasketState['duration'];
  optInChoice?: MembershipOptIn;
  user?: User;
  onConfirmPaywall: () => void;
  onOptInChoiceSelection: (newOptInChoice: MembershipOptIn) => void;
};

const SpotContent = ({ duration, optInChoice, user, onConfirmPaywall, onOptInChoiceSelection }: SpotContentProps) => {
  const { prices, pricesError } = useGetPrices();

  return (
    <StickyContainer>
      <Content>
        <WellnessCleaningSpotHeader />
        <StyledWhiteSpacerRoundedBorders />
        <PriceCardsContainer data-testid={prices ? MEMBERSHIP_PAYWALL_CLEANING_PRICES_LOADED_TEST_ID : undefined}>
          <SelectableCleaningStandardPriceCard
            optInChoice={optInChoice}
            onPress={onOptInChoiceSelection}
            prices={prices}
            isLoadingPrices={!prices || !!pricesError}
            duration={duration}
          />
          <SelectableCleaningMemberPriceCard
            optInChoice={optInChoice}
            onPress={onOptInChoiceSelection}
            prices={prices}
            isLoadingPrices={!prices || !!pricesError}
            duration={duration}
          />
        </PriceCardsContainer>
        <MembershipFaq
          title={t('.faq.title')}
          questions={getMembershipQuestions({
            universeReference: 'cleaning',
            isSpotCleaning: true,
            user,
          })}
        />
      </Content>
      <StyledStickyBottomWrapper>
        <Button size='lg' onPress={onConfirmPaywall} hasFullWidth disabled={!optInChoice}>
          {getMembershipPaywallCTAText(optInChoice)}
        </Button>
      </StyledStickyBottomWrapper>
    </StickyContainer>
  );
};

export default SpotContent;
